// extracted by mini-css-extract-plugin
export default {"wrapper":"image-placeholder_wrapper__3PZJM","emptyBox":"image-placeholder_emptyBox__SqU1M"};